import React, { useState } from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import Image from "../components/form-components/Image";
import Fields from "../components/form-components/Fields";
import Button from "../components/form-components/Button";

import { resetPasswordLink } from "../features/auth/reset-password/resetPasswordSlice";
import Yup from "../validations/validationsLib";
import logo from "../assets/images/DocoMatic_beta.svg";
import eyeline from "../assets/images/eyelineicn.svg";
import eye from "../assets/images/eyeicn.svg";
import { OK } from "../constants/statusCode";
import { showError, showSuccess } from "../utils/messageHelper";

export default function ResetPassword() {
  const { id } = useParams();

  const [togglePassword, setTogglePassword] = useState(false);

  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  return (
    <>
      <Formik
        initialValues={{
          password: "",
          confirmPassword: "",
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .matches(
              /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/,
              "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
            )
            .required("New password cannot be blank!"),
          confirmPassword: Yup.string()
            .oneOf(
              [Yup.ref("password"), null],
              "Password & confirm password must be same."
            )
            .required("Confirm password cannot be blank!"),
        })}
        onSubmit={async (values) => {
          const { payload } = await dispatch(
            resetPasswordLink({ password: values.password, id: id })
          );
          if (payload.status === OK) {
            showSuccess(payload.data.responseMessage);
            navigate("/login");
          } else {
            showError(payload?.response?.data?.responseMessage);
          }
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          touched,
          isSubmitting,
          errors,
          handleSubmit,
          setFieldValue,
        }) => (
          <Form>
            <div className="form-pages d-flex align-items-center">
              <div className="form-box">
                <span className="logo text-center">
                  <Image src={logo} alt="" />
                </span>
                <h1>Reset Password</h1>

                <div className="form-group form-grp-passsword">
                  <Fields
                    type={togglePassword ? "text" : "password"}
                    placeholder="Password"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="password"
                    value={values.password}
                    className="form-control"
                    onChange={handleChange}
                  />
                  <span
                    className={`icon-${togglePassword ? "Hide" : "Hide"}`}
                    onClick={() => setTogglePassword(!togglePassword)}
                  >
                    <img
                      className="eye-icn"
                      src={togglePassword ? eye : eyeline}
                      alt="show password"
                    />
                  </span>
                </div>
                <div className="form-group form-grp-passsword">
                  <Fields
                    type={toggleConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="confirmPassword"
                    value={values.confirmPassword}
                    className="form-control"
                    onChange={handleChange}
                  />
                  <span
                    className={`icon-${toggleConfirmPassword ? "Hide" : "Hide"
                      }`}
                    onClick={() =>
                      setToggleConfirmPassword(!toggleConfirmPassword)
                    }
                  >
                    <img
                      className="eye-icn"
                      src={toggleConfirmPassword ? eye : eyeline}
                      alt="show password"
                    />
                  </span>
                </div>

                <div className="form-group">
                  <Button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 mt-1"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    Reset Password
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
